import { Entity } from '@sqior/js/entity';
import { CoreEntities } from './core-definitions';
import { EntityModel } from './entity';

/* Base entity for entities that uniquely identify something */

export type KeyEntity = Entity;
export const KeyEntityModel: EntityModel = { type: CoreEntities.Key, props: [] };
